import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Button,
  Container,
  Row,
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import Select from "react-select";
import LineChart from "./LineChart";
import BarChart from "./BarChart";
import Alert from "../common/Alert";
import userService from "../../api-service/UserService";
import {
  LOGERROR,
  MONTHS,
  BAR_CHART_OPTIONS,
  DATE_FORMAT,
  TILLAGE_TYPES,
  DUPLICATE_CROP,
  ACRES_EXECEEDED,
  DANGER,
  USER_DETAILS,
  SHARED_FIELDS,
  SESSION_EXPIRED,
  SESSION_EXPIRED_MESSAGE,
  INFO,
  EMPTY,
  DASHBOARD_TABLE_CUSTOM_STYLES,
} from "../../configurations/Constants";
import CropService from "../../api-service/CropService";
import { useSelector, useDispatch } from "react-redux";
import {
  setAllGeoJsonPolygon,
  SetFlagToGetGeoJson,
  SetEntities,
} from "../../configurations/redux-configurations/actions/fieldAction";
import { setUserDetails } from "../../configurations/redux-configurations/actions/userAction";
import {
  SELECT_CUSTOM_DATE,
  CROP_TILLAGE_SHOULD_NOT_BE_EMPTY,
  CROP_UNIQUE_FOR_SEASON,
  YEAR_ACRES_ZERO_CANNOT_ADD_CROP,
  CROP_ALREADY_EXIST,
  RELOAD_PAGE_TRY_AGAIN,
  CROP_ACRES_NOT_EXCEED_FIELD_ACRES,
  ERROR_SAVING_CROP_DETAILS,
  ERROR_WHILE_SAVING_DATA,
  SESSION_HAS_EXPIRED,
  LOADING_GRAPHS,
  LOADING_DASHBOARD_DATA,
  DAILY_IRRIGATION_ACTIVITY,
  DAILY_WATER_USAGE,
  SELECT_FIELD_FOR_DAILY_WATER_USAGE,
  YEARLY_IRRIGATION_ACTIVITY,
  MONTHLY_WATER_USAGE,
  SELECT_FIELD_FOR_MONTHLY_WATER_USAGE,
  RESETTING_FIELD_DATA,
  NO_FIELDS_REGISTER_IN_MAP,
  NO_MATCHING_RECORDS,
  SAVING_FIELD_DATA,
  FIELD_DETAILS_SAVED_SUCCESSFULLY,
  INCOMING_TOKEN_HAS_EXPIRED,
  INVALID_CREDENTIALS,
  ERROR_FETCHING_METER_DATA,
  ERROR_FETCHING_ALL_IRRIGATION_FIELDS,
  ERROR_LOADING_GISC_DATA,
  ERROR_FETCHING_GRAPH_DATA,
  ERROR_SAVING_FIELD_DETAILS,
  ERROR_FETCHING_SHARE_FIELD_DETAILS,
} from "../../configurations/MessageConstants";
import FluentdHelper from "../../helpers/FluentdHelper";
import SessionHelper from "../../helpers/SessionHelper";
import DashboardHelper from "../../helpers/DashboardHelper";
import StorageHelper from "../../helpers/StorageHelper";
import GisLayerService from "../../api-service/GisLayerService";
import LoadingOverlay from "../common/LoadingOverlay";
import DateRangePicker from "./DateRangePicker";
import { format, isValid } from "date-fns";
import DataTable from "react-data-table-component";
import { StatusCodes } from "../../configurations/status-codes";
import StaffUserNotes from "../staff/StaffUserNotes";
import ConsentPopup from "./ConsentPopup";

let businessData = [];
let farmData = [];
let farmDataReset = [];
let cropTypeData = [];
let yearData = [];
let tableData = [];
let tableValues = {
  selectedYear: new Date().getFullYear(),
  selectedRangeYear: EMPTY,
};

export function Dashboard() {
  const dispatch = useDispatch();
  const CropsValue = useSelector((state) => state.field.crops);
  const TillagesValue = useSelector((state) => state.field.tillages);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const monthData = MONTHS;

  const [year, setYear] = useState({
    value: new Date().getFullYear(),
    label: new Date().getFullYear(),
  });
  const [month, setMonth] = useState([]);
  const [business, setBusiness] = useState([]);

  const [farm, setFarm] = useState([]);
  const [cropType, setCropType] = useState([]);
  const [tillage, setTillage] = useState([]);
  const [userFieldData, setUserFieldData] = useState({});

  const [filteredData, setFilteredData] = useState([]);
  const [chartTitle, setChartTitle] = useState(EMPTY);
  const [barChartTitleFieldName, setBarChartTitleFieldName] = useState(EMPTY);
  const [barChartTitleRange, setBarChartTitleRange] = useState(EMPTY);
  const [showMessage, setShowMessage] = useState(EMPTY);
  const [series, setSeries] = useState([
    { name: EMPTY, data: [] },
    { name: EMPTY, data: [] },
  ]);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [graphOverlayLoading, setGraphOverlayLoading] = useState(false);
  const [cropUpdated, setCropUpdated] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [variant, setVariant] = useState(EMPTY);
  const [overlayText, setOverlayText] = useState(LOADING_DASHBOARD_DATA);

  const [barOptions, setBarOptions] = useState({ ...BAR_CHART_OPTIONS });
  const [barSeries, setBarSeries] = useState([
    { name: "In./Day", data: Array(15).fill(0) },
  ]);
  const [cropData, setCropData] = useState([]);
  const [seasonAllowed, setSeasonAllowed] = useState([]);
  const [selectRangeStatus, setSelectRangeStatus] = useState(false);
  const [acresYearData, setAcresYearData] = useState({});
  const [yearChanged, setYearChanged] = useState(false);
  const [monthChanged, setMonthChanged] = useState(false);
  const [dateRangeChanged, setDateRangeChanged] = useState(false);
  const [dataProcessing, setDataProcessing] = useState(false);
  const [showNoRowsMessage, setShowNoRowsMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [startDate, setStartDate] = useState(EMPTY);
  const [endDate, setEndDate] = useState(EMPTY);
  const [range, setRange] = useState({});
  const [datePopoverOpen, setDatePopoverOpen] = useState(false);
  const [visibleMonths, setVisibleMonths] = useState(new Date());

  const [editingRowId, setEditingRowId] = useState(null);
  const [selectedCrop, setSelectedCrop] = useState({});
  const [selectedTillage, setSelectedTillage] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);

  const tillageInfo = (
    <div>
      <h3>
        <OverlayTrigger
          rootClose
          placement="bottom"
          overlay={
            <Popover id="info-popover">
              <Popover.Body>
                {Object.entries(TILLAGE_TYPES).map(([key, value]) => (
                  <p key={key}>
                    <b>{key}:</b> {value}
                  </p>
                ))}
              </Popover.Body>
            </Popover>
          }
        >
          <Button
            variant="secondary"
            className="info-button fa fa-info-circle mt-1"
          />
        </OverlayTrigger>
      </h3>
    </div>
  );

  const columns = [
    {
      id: 1,
      selector: (row) => row.id,
      cell: (row) => (
        <Form.Check
          className="ps-3"
          type="radio"
          name="field-radio"
          id={row.id}
          checked={selectedRow?.id === row.id}
          onChange={() => handleSelectedRow(row)}
        />
      ),
      width: "1rem",
    },
    {
      id: 2,
      name: "Field Name",
      selector: (row) => row.field_name,
      sortable: true,
      reorder: true,
      value: "field_name",
      width: "11rem",
    },
    {
      id: 3,
      name: "Acres",
      selector: (row) => row.acres_utilized,
      sortable: true,
      sortFunction: (rowA, rowB) =>
        numberSortFunction(rowA, rowB, "acres_utilized"),
      reorder: true,
      value: "acres_utilized",
      width: "5rem",
    },
    {
      id: 4,
      name: "Inches/Acre",
      selector: (row) => row.inches_acres,
      sortable: true,
      sortFunction: (rowA, rowB) =>
        numberSortFunction(rowA, rowB, "inches_acres"),
      reorder: true,
      value: "inches_acres",
      width: "8rem",
    },
    {
      id: 5,
      name: "GW-Area",
      selector: (row) => row.area,
      sortable: true,
      sortFunction: (rowA, rowB) => areaSortFunction(rowA, rowB),
      reorder: true,
      value: "area",
      width: "7rem",
    },
    {
      id: 6,
      name: "Crop",
      selector: (row) => row.crop,
      sortable: true,
      reorder: true,
      value: "crop",
      width: "8rem",
      cell: (row) => {
        const isEditable = row.isEditable && row.id === editingRowId;
        return isEditable ? (
          <div className="d-inline-block w-auto">
            <select
              value={selectedCrop || row.crop}
              onChange={(e) => setSelectedCrop(e.target.value)}
            >
              <option value={EMPTY} disabled>
                Select Crop
              </option>
              {cropTypeData?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <>{row.crop}</>
        );
      },
    },
    {
      id: 7,
      name: (
        <div className="d-flex align-items-center">
          <span>Tillage</span>
          <span>{tillageInfo}</span>
        </div>
      ),
      selector: (row) => row.tillage,
      sortable: true,
      reorder: true,
      width: "7rem",
      value: "tillage",
      cell: (row) => {
        const isEditable = row.isEditable && row.id === editingRowId;
        return isEditable ? (
          <div className="d-inline-block w-auto">
            <select
              value={selectedTillage || row.tillage}
              onChange={(e) => setSelectedTillage(e.target.value)}
            >
              <option value={EMPTY} disabled>
                Select Tillage
              </option>
              {Object.entries(TILLAGE_TYPES).map(([key]) => (
                <option key={key} value={key}>
                  {key}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <>{row.tillage}</>
        );
      },
    },
    {
      id: 8,
      cell: (row) =>
        row.isEditable ? (
          editingRowId === row.id ? (
            <>
              <i
                className="fa fa-save"
                title="Save Changes"
                onClick={() => handleSaveChanges(row.id)}
              ></i>
              <i
                className="fa fa-close"
                title="Cancel Crop"
                onClick={() => handleCancelEdit(row.id)}
              ></i>
            </>
          ) : (
            <>
              <i
                className="fa fa-edit"
                title="Edit Row"
                onClick={() => handleEditClick(row.id)}
              ></i>
            </>
          )
        ) : null,
      width: "4rem",
    },
  ];

  const isGeoJsonFetched = useSelector(
    (state) => state.field.isGeoJsonPolygonFetched
  );

  useEffect(() => {
    (async function () {
      await getDashboardData();
    })();
  }, []);

  useEffect(() => {
    if (userFieldData && userFieldData.data && userFieldData.data.fields) {
      loadTableDetails();
    }
  }, [userFieldData]);

  const getDashboardData = async () => {
    setOverlayLoading(true);
    setOverlayText(LOADING_DASHBOARD_DATA);
    if (!isGeoJsonFetched) {
      loadAllIrrigationFields();
    }
    if (document.getElementById("jsd-widget")) {
      document.getElementById("jsd-widget").style.opacity = "1";
    }
    const currentSeasonYear = DashboardHelper.getSeasonalYear();
    if (CropsValue.length === 0 || TillagesValue.length === 0) {
      getCropsAndTillages();
    }

    const [shareFieldDataValue, meterData] = await Promise.all([
      getFieldShareDetails(),
      getUserWaterData(currentSeasonYear, [], []),
    ]);
    const seasonAllowedValue =
      DashboardHelper.getValidatedSeasons(shareFieldDataValue);
    const acresYearDataValue = DashboardHelper.getAcresYearData(meterData);
    if (meterData.data) {
      meterData.data.fields.length === 0
        ? setShowNoRowsMessage(true)
        : setShowNoRowsMessage(false);
    } else {
      setShowNoRowsMessage(false);
    }
    setSeasonAllowed(seasonAllowedValue);
    setAcresYearData(acresYearDataValue);
    setYear({
      value: currentSeasonYear,
      label: currentSeasonYear,
    });
    setUserFieldData(meterData);
  };

  const loadTableDetails = () => {
    let tableRows = [];
    let currentYear;

    if (year.value) {
      currentYear = year.value;
    } else {
      let startDateValue = new Date(startDate);
      currentYear = startDateValue.getFullYear();
    }

    const cropDataValue = DashboardHelper.getCropData(
      cropUpdated,
      userFieldData,
      seasonAllowed,
      cropData,
      currentYear
    );

    cropDataValue.forEach((value, key) => {
      const isSharedField = value.is_shared_field;
      let canEdit = true;
      if (isSharedField) {
        let season = seasonAllowed.filter((field) => {
          return (
            field.year.toString() === currentYear.toString() &&
            field.fieldId === value.field_id
          );
        });
        if (season.length === 1 && season[0].permission === false) {
          canEdit = false;
        }
      }
      tableRows.push({ id: key, ...value, isEditable: canEdit });
      businessData = DashboardHelper.setBusinessArray(businessData, key, value);
      farmData = DashboardHelper.setFarmArray(business, farmData, key, value);
      farmDataReset = farmData;
    });
    cropTypeData = DashboardHelper.setCropTypeArray(cropTypeData, CropsValue);
    yearData = DashboardHelper.setYearDataArray(yearData);

    setCropData(cropDataValue);
    tableData = tableRows;
    filterData(tableRows);
    setOverlayLoading(false);
  };

  const filterData = (dataRows) => {
    const meterData = userFieldData.data.inches_per_acre;
    let filteredRows = dataRows;
    let yearValue = {
      value: new Date().getFullYear(),
      label: new Date().getFullYear(),
    };
    let electricDetail = [];
    let selectedYearValue = new Date().getFullYear();
    let selectedRangeYearValue = EMPTY;

    /* Filtering by Year and Month -- if year is not selected, default is kept to current year */
    if (year.length !== 0 || month.length !== 0) {
      let filterYear = year;
      if (filterYear.length === 0) {
        filterYear = yearValue;
        setYear(filterYear);
      }
      electricDetail = DashboardHelper.FilterByYearMonth(
        meterData,
        electricDetail,
        filterYear.label,
        month
      );
      selectedYearValue = filterYear.label;
      selectedRangeYearValue = EMPTY;
      inchesPerAcre(electricDetail);
    }

    /* Date Range filter */
    if (startDate && endDate) {
      let startDateValue = new Date(startDate);
      electricDetail = DashboardHelper.FilterByDateRange(
        meterData,
        electricDetail,
        seasonAllowed,
        yearValue.label
      );
      selectedYearValue = startDateValue.getFullYear();
      selectedRangeYearValue = new Date(startDate).getFullYear();
      inchesPerAcre(electricDetail);
    }

    /* Business filter */
    if (business.length !== 0) {
      filteredRows = filteredRows.filter((data) =>
        business.some((objValue) => objValue.label === data.business_name)
      );
    }
    /* Farm filter */
    if (farm.length !== 0) {
      filteredRows = filteredRows.filter((data) =>
        farm.some((objValue) => objValue.label === data.farm_name)
      );
    }
    /* Crop Type filter */
    if (cropType.length !== 0) {
      filteredRows = filteredRows.filter((data) =>
        cropType.some((objValue) => objValue.label === data.crop)
      );
    }
    /* Tillage filter */
    if (tillage.length !== 0) {
      filteredRows = filteredRows.filter((data) =>
        tillage.some((objValue) => objValue.label === data.tillage)
      );
    }
    setFilteredData(filteredRows);

    /* Reset selected Field */
    document.getElementsByName("chart-render").forEach((btn) => {
      btn.checked = false;
    });

    tableValues.selectedYear = selectedYearValue;
    tableValues.selectedRangeYear = selectedRangeYearValue;

    setBarChartTitleFieldName(EMPTY);
    setBarChartTitleRange(EMPTY);
    setChartTitle(EMPTY);
    setYearChanged(false);
    setMonthChanged(false);
    setDateRangeChanged(false);
    setDataProcessing(false);
  };

  const numberSortFunction = (rowA, rowB, field) => {
    const valueA = parseFloat(rowA[field]);
    const valueB = parseFloat(rowB[field]);
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  };

  const areaSortFunction = (rowA, rowB) =>
    String(rowA.area ?? EMPTY).localeCompare(String(rowB.area ?? EMPTY), undefined, {
      numeric: true,
      sensitivity: "base",
    });

  const handleEditClick = (rowId) => {
    const row = filteredData.find((row) => row.id === rowId);
    setSelectedCrop(row.crop);
    setSelectedTillage(row.tillage);
    setEditingRowId(rowId);
  };

  const handleCancelEdit = (rowId) => {
    const row = filteredData.find((row) => row.id === rowId);
    setSelectedCrop(row.crop);
    setSelectedTillage(row.tillage);
    setEditingRowId(null);
  };

  const handleSaveChanges = (rowId) => {
    const row = filteredData.find((row) => row.id === rowId);
    saveFieldDetail(row);
  };

  const inchesPerAcre = (electricDetail) => {
    tableData = DashboardHelper.getInchesPerAcre(
      tableData,
      electricDetail,
      acresYearData
    );
  };

  const resetSelectedRows = () => {
    if (editingRowId) handleCancelEdit(editingRowId);
    setSelectedRow(null);
  };

  const resetFilter = async () => {
    await SessionHelper.handleRefreshToken();
    resetSelectedRows();
    closeAlert();
    let barOptionsResetValue = {
      ...BAR_CHART_OPTIONS,
      dataLabels: {
        enabled: true,
      },
    };

    tableValues.selectedYear = new Date().getFullYear();
    const currentSeasonYear = DashboardHelper.getSeasonalYear();
    document.getElementById("custom-switch").checked = false;
    setDateFilter(false);
    setStartDate(EMPTY);
    setEndDate(EMPTY);
    setRange({});
    setVisibleMonths(new Date());
    setYear({
      value: currentSeasonYear,
      label: currentSeasonYear,
    });
    setMonth([]);
    setBusiness([]);
    setFarm([]);
    setCropType([]);
    setTillage([]);
    setCropUpdated(false);
    setBarChartTitleFieldName(EMPTY);
    setBarChartTitleRange(EMPTY);
    setChartTitle(EMPTY);
    setBarOptions(barOptionsResetValue);
    setBarSeries([{ name: "In./Day", data: Array(15).fill(0) }]);
    setCropData([]);
    setDataProcessing(true);
    const meterDataYearwise = await getUserWaterData(currentSeasonYear, [], []);
    setSelectRangeStatus(false);
    setYearChanged(false);
    setMonthChanged(false);
    setDateRangeChanged(false);
    setOverlayLoading(false);
    setCropUpdated(false);
    setUserFieldData(meterDataYearwise);
  };

  /* Select filter type for Date (Date Range or specific year and month) */
  const setDateFilter = (changeStatus) => {
    let checkboxId = document.getElementById("custom-switch");
    if (checkboxId.checked) {
      document.getElementById("DateFilter").classList.add("hide");
      document.getElementById("DateFilterRange").classList.remove("hide");
      setYear([]);
      setMonth([]);
    } else {
      document.getElementById("DateFilter").classList.remove("hide");
      document.getElementById("DateFilterRange").classList.add("hide");
      setStartDate(EMPTY);
      setEndDate(EMPTY);
      setRange({});
      setVisibleMonths(new Date());
    }
    if (changeStatus) {
      setSelectRangeStatus(!selectRangeStatus);
    }
  };
  /* Convert and set start and end date for date range */
  const handleDayClick = (day) => {
    if (range.from && range.to) {
      setStartDate(EMPTY);
      setEndDate(EMPTY);
      setRange({});
    } else if (!range.from) {
      setRange({ from: day, to: undefined });
      setStartDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
      setEndDate(EMPTY);
    } else if (range.from && !range.to) {
      if (day > range.from) {
        setRange({ ...range, to: day });
        setEndDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
      } else {
        setRange({ from: day, to: range.from });
        setStartDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
        setEndDate(
          isValid(range.from) ? format(range.from, DATE_FORMAT) : EMPTY
        );
      }
      setDatePopoverOpen(false);
    }
    setDateRangeChanged(true);
  };

  /* Set state on select of dropdown values from Select */
  const handleSelectChange = (selectedOptions, stateName) => {
    switch (stateName.name) {
      case "month":
        {
          const monthHasChanged = month === selectedOptions ? false : true;
          const monthValue = selectedOptions === null ? [] : selectedOptions;
          setMonth(monthValue);
          setMonthChanged(monthHasChanged);
        }
        break;
      case "business":
        {
          const businessValue = selectedOptions === null ? [] : selectedOptions;
          setBusiness(businessValue);

          businessValue.length !== 0
            ? (farmData = [])
            : (farmData = farmDataReset);
          setFarm([]);

          tableData.forEach((value, key) => {
            if (businessValue.length !== 0) {
              if (
                businessValue.some(
                  (objValue) => objValue.label === value.business_name
                )
              ) {
                if (
                  !farmData.some(
                    (objValue) => objValue.label === value.farm_name
                  )
                ) {
                  farmData.push({ value: key, label: value.farm_name });
                }
              }
            } else {
              if (
                !farmData.some((objValue) => objValue.label === value.farm_name)
              ) {
                farmData.push({ value: key, label: value.farm_name });
              }
            }
          });
        }
        break;
      case "farm":
        setFarm(selectedOptions === null ? [] : selectedOptions);
        break;
      case "cropType":
        setCropType(selectedOptions === null ? [] : selectedOptions);
        break;
      case "tillage":
        setTillage(selectedOptions === null ? [] : selectedOptions);
        break;
      default:
        break;
    }
  };

  const onChangeYear = (e) => {
    let yearHasChanged =
      year.length !== 0 && year.label.toString() === e.label.toString()
        ? false
        : true;
    setYear(e);
    setYearChanged(yearHasChanged);
  };

  const updateTableData = async () => {
    await SessionHelper.handleRefreshToken();
    resetSelectedRows();
    closeAlert();
    if (month === null) setMonth([]);
    if (business === null) setBusiness([]);
    if (farm === null) setFarm([]);
    if (cropType === null) setCropType([]);
    if (tillage === null) setTillage([]);

    let meterDataYearwise = userFieldData;
    let currentYear = EMPTY;
    let startDateValue = EMPTY;
    let endDateValue = EMPTY;
    let monthSelected = [];
    let rangeSelected = [];
    month.forEach((item) => {
      monthSelected.push(item.value);
    });
    if (year.length === 0 && month.length === 0 && (!startDate || !endDate)) {
      setShowAlert(true);
      setAlertMessage(SELECT_CUSTOM_DATE);
      setVariant(DANGER);
      return false;
    }
    if (
      yearChanged === true ||
      monthChanged === true ||
      dateRangeChanged === true
    ) {
      setOverlayLoading(true);
      if (year.value) {
        currentYear = year.value.toString();
      } else if (startDate && endDate) {
        startDateValue = new Date(startDate);
        endDateValue = new Date(endDate);
        rangeSelected.push(startDateValue, endDateValue);
        currentYear = startDateValue.getFullYear().toString();
      } else {
        currentYear = new Date().getFullYear();
      }
      meterDataYearwise = await getUserWaterData(
        currentYear,
        monthSelected,
        rangeSelected
      );
      setOverlayLoading(false);
    }
    setCropUpdated(false);
    setUserFieldData({ ...meterDataYearwise });
  };

  const getCropsAndTillages = async () => {
    const user_email = loggedInUser;
    try {
      const response = await CropService.getCropsAndTillages();
      let { CropArray, TillageArray } =
        DashboardHelper.generateCropsAndTillagesArray(response.data.data);
      dispatch(SetEntities(CropArray, TillageArray));
    } catch (error) {
      setShowAlert(true);
      setAlertMessage(ERROR_LOADING_GISC_DATA);
      setVariant(DANGER);
      FluentdHelper.logEvent(
        `Exception threw while fetching all Crops and Tillages.`,
        "Dashboard_getCropsAndTillages",
        user_email,
        {
          response: error,
        },
        LOGERROR
      );
    }
  };

  const handleSelectedRow = async (row) => {
    if (!row) {
      return;
    }
    setSelectedRow(row);
    updateChart(row);
  };

  useEffect(() => {
    if (!filteredData.length) return;
    setSelectedRow(filteredData[0]);
    updateChart(filteredData[0]);
  }, [filteredData]);

  useEffect(() => {
    if (!selectedRow) {
      drawLineChart(null, []);
      drawBarChart(null, {});
    }
  }, [selectedRow]);

  const updateChart = async (selectedFieldValue) => {
    const { selectedYear, selectedRangeYear } = tableValues;
    setGraphOverlayLoading(true);
    let currentYear = selectedYear;
    if (selectedRangeYear !== EMPTY) {
      currentYear = selectedRangeYear;
    }
    let startDateElement = new Date(startDate);
    let endDateElement = new Date(endDate);
    let { barGraphEndDate, barGraphStartDate } = DashboardHelper.calcGraphDays(
      month,
      selectedYear,
      startDate,
      endDate,
      startDateElement,
      endDateElement
    );

    let start_date =
      barGraphStartDate.getFullYear() +
      "-" +
      ("0" + (barGraphStartDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + barGraphStartDate.getDate()).slice(-2);

    let end_date =
      barGraphEndDate.getFullYear() +
      "-" +
      ("0" + (barGraphEndDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + barGraphEndDate.getDate()).slice(-2);

    const title = selectedFieldValue.field_name + " - " + currentYear;
    const barTitle = selectedFieldValue.field_name;
    const barRange = "From " + start_date + " to " + end_date;
    setChartTitle(title);
    setBarChartTitleFieldName(barTitle);
    setBarChartTitleRange(barRange);

    const irrig_unit_id = selectedFieldValue.irrig_unit_id;
    const farm_practice_id = selectedFieldValue.farm_practice_id;
    const graphParam = `?irrig_unit_id=${irrig_unit_id}&farm_practice_id=${farm_practice_id}&start_date=${start_date}&end_date=${end_date}`;

    try {
      const response = await userService.getUserGraphData(graphParam);
      const barGraphElectricDataValue = response.data.data.days;
      const lineGraphElectricDataValue = response.data.data.months;

      drawLineChart(selectedFieldValue, lineGraphElectricDataValue);
      drawBarChart(selectedFieldValue, barGraphElectricDataValue);
    } catch (error) {
      console.error(ERROR_FETCHING_GRAPH_DATA, error);
    }
  };

  const drawLineChart = (selectedFieldValue, lineGraphElectricDataValue) => {
    let eData = lineGraphElectricDataValue;
    let lineGraphData = {
      cumulativeArray: Array(12).fill("0.00"),
      fieldArray: Array(12).fill("0.00"),
    };

    // Initial state = Message to select a field is displayed
    !selectedFieldValue
      ? setShowMessage("message")
      : setShowMessage("hide-message");

    if (selectedFieldValue) {
      lineGraphData = DashboardHelper.getLineChartDetails(lineGraphData, eData);
    }
    setSeries([
      { name: "Cumulative", data: lineGraphData.cumulativeArray },
      { name: "In./MO", data: lineGraphData.fieldArray },
    ]);

    setGraphOverlayLoading(false);
  };

  const drawBarChart = (selectedFieldValue, barGraphElectricDataValue) => {
    const { selectedYear } = tableValues;
    const startDateElement = new Date(startDate);
    const endDateElement = new Date(endDate);
    let { GraphDayCount, barGraphEndDate } = DashboardHelper.calcGraphDays(
      month,
      selectedYear,
      startDate,
      endDate,
      startDateElement,
      endDateElement
    );
    let sharedFieldDetails = [];
    let showBarChart = false;
    let sharedField = false;
    let currentYear = selectedYear;

    // Initial state = Message to select a field is displayed
    !selectedFieldValue
      ? setShowMessage("message")
      : setShowMessage("hide-message");

    if (selectedFieldValue) {
      sharedFieldDetails = seasonAllowed.filter(
        (season) => season.fieldId === selectedFieldValue.field_id
      );
      if (sharedFieldDetails.length > 0) {
        sharedField = true;
        showBarChart =
          sharedFieldDetails.filter(
            (f) => f.year.toString() === currentYear.toString()
          ).length === 0
            ? false
            : true;
      }
    }

    const { optionValue, seriesValue } = DashboardHelper.getBarChartDetails(
      barGraphElectricDataValue,
      sharedField,
      selectedFieldValue,
      showBarChart,
      GraphDayCount,
      barGraphEndDate
    );
    let barOptionValue = {
      ...BAR_CHART_OPTIONS,
      xaxis: {
        categories: optionValue,
      },
    };

    setBarSeries([{ ...barSeries, data: seriesValue }]);
    setBarOptions(barOptionValue);
    setGraphOverlayLoading(false);
  };

  const saveFieldDetail = async (fieldRow) => {
    if (!fieldRow) return;
    await SessionHelper.handleRefreshToken();

    let { selectedYear } = tableValues;
    let cropDataValue = cropData;
    let userFieldDataValue = userFieldData;

    setOverlayLoading(true);
    setOverlayText(SAVING_FIELD_DATA);

    let fieldId = fieldRow.field_id;
    let irrigUnitId = fieldRow.irrig_unit_id;
    let cropId = parseFloat(fieldRow.crop_id);
    let acres_utilized = fieldRow.acres_utilized;
    let total_acres = fieldRow.total_acres;

    const warning = CropUpdateWarnings(
      selectedCrop,
      selectedTillage,
      cropDataValue,
      selectedYear,
      fieldId,
      cropId,
      acres_utilized
    );
    if (warning === true) return;

    try {
      let updatedCrops = [
        {
          acres: acres_utilized === EMPTY ? total_acres : acres_utilized,
          tillage: selectedTillage,
          crop: selectedCrop,
          deleted: false,
        },
      ];

      if (cropId !== null) {
        updatedCrops[0].id = parseFloat(cropId);
      }
      let payload = {
        field_id: parseFloat(fieldId),
        irrig_unit_id: irrigUnitId,
        year: selectedYear,
        farm_practices: updatedCrops,
      };
      const response = await CropService.updateCropDetails(payload);
      const updatedData = DashboardHelper.UpdateFieldAndCropDataArray(
        response,
        cropDataValue,
        userFieldDataValue,
        fieldRow,
        selectedYear,
        selectedCrop,
        selectedTillage
      );

      userFieldDataValue = updatedData.userFieldDataValue;
      cropDataValue = updatedData.cropDataValue;
      setAlertMessage(FIELD_DETAILS_SAVED_SUCCESSFULLY);
      setVariant(INFO);
      setShowAlert(true);
      setCropData([...cropDataValue]);
      setCropUpdated(true);
      setUserFieldData({ ...userFieldDataValue });
      setOverlayLoading(false);
      setEditingRowId(null);
    } catch (error) {
      console.error(ERROR_SAVING_FIELD_DETAILS, error);
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        let responseData = error.response.data;
        let errorMessage = ERROR_WHILE_SAVING_DATA;
        if (responseData.data === DUPLICATE_CROP) {
          errorMessage = CROP_ALREADY_EXIST + ", " + RELOAD_PAGE_TRY_AGAIN;
        } else if (responseData.data === ACRES_EXECEEDED) {
          errorMessage =
            CROP_ACRES_NOT_EXCEED_FIELD_ACRES + ", " + RELOAD_PAGE_TRY_AGAIN;
        }
        setOverlayLoading(false);
        setShowAlert(true);
        setAlertMessage(errorMessage);
        setVariant(DANGER);
      } else {
        setOverlayLoading(false);
        setShowAlert(true);
        setAlertMessage(ERROR_SAVING_CROP_DETAILS);
        setVariant(DANGER);
        return false;
      }
    }
  };

  const CropUpdateWarnings = (
    selectedCrop,
    selectedTillage,
    cropDataValue,
    selectedYearValue,
    fieldId,
    cropId,
    acres_utilized
  ) => {
    let currentCrops = [];
    if (selectedCrop === EMPTY || selectedTillage === EMPTY) {
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(CROP_TILLAGE_SHOULD_NOT_BE_EMPTY);
      setVariant(DANGER);
      return true;
    }
    if (isNaN(cropId)) {
      currentCrops = cropDataValue.filter(
        (crop) => crop.field_id === fieldId && crop.year === selectedYearValue
      );
    } else {
      currentCrops = cropDataValue.filter(
        (crop) =>
          crop.field_id === fieldId &&
          crop.year === selectedYearValue &&
          crop.crop_id !== cropId
      );
    }
    let cropArr = currentCrops.map((crop) => {
      return crop.crop;
    });

    let isDuplicate = cropArr.includes(selectedCrop);
    if (isDuplicate === true) {
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(CROP_UNIQUE_FOR_SEASON);
      setVariant(DANGER);
      return true;
    }
    if (parseFloat(acres_utilized) === 0) {
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(YEAR_ACRES_ZERO_CANNOT_ADD_CROP);
      setVariant(DANGER);
      return true;
    }
  };

  const getFieldShareDetails = async () => {
    let user_email = loggedInUser;
    try {
      let payload = {
        user_email: user_email,
        keys: [USER_DETAILS, SHARED_FIELDS],
      };
      const response = await userService.getUserFieldDetails(payload);
      const shareFieldDataValue = response.data;
      dispatch(setUserDetails(shareFieldDataValue.data.user));
      return shareFieldDataValue.data.shared;
    } catch (error) {
      setAlertMessage(ERROR_LOADING_GISC_DATA);
      setVariant(DANGER);
      setShowAlert(true);

      FluentdHelper.logEvent(
        ERROR_FETCHING_SHARE_FIELD_DETAILS,
        "Dashboard_getFieldShareDetails",
        user_email,
        {
          request: {
            user_email: user_email,
            keys: [SHARED_FIELDS],
          },
          response: error,
        },
        LOGERROR
      );
    }
  };

  const getUserWaterData = async (currentYear, monthArr, rangeArr) => {
    const queryUrl = DashboardHelper.getWaterDataQueryUrl(
      currentYear,
      monthArr,
      rangeArr
    );
    let user_email = loggedInUser;
    try {
      const response = await userService.getUserWaterData(queryUrl);
      const meterData = response.data;
      return response.status === StatusCodes.OK ? meterData : {};
    } catch (error) {
      let responseData = error.response.data;
      console.error(ERROR_FETCHING_METER_DATA, error);
      if (
        error.response.status === StatusCodes.UNAUTHORIZED &&
        responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
      ) {
        FluentdHelper.logEvent(
          INVALID_CREDENTIALS,
          "Dashboard_getUserWaterData",
          user_email,
          {
            request: queryUrl,
            response: responseData,
          },
          LOGERROR
        );
        StorageHelper.setItem(SESSION_EXPIRED, true);
        StorageHelper.setItem(SESSION_EXPIRED_MESSAGE, SESSION_HAS_EXPIRED);
        SessionHelper.cleanUpStorageKeys();
        window.location.reload();
      } else {
        setAlertMessage(ERROR_LOADING_GISC_DATA);
        setVariant(DANGER);
        setShowAlert(true);
        FluentdHelper.logEvent(
          ERROR_FETCHING_METER_DATA,
          "Dashboard_getUserWaterData",
          user_email,
          {
            response:
              error.response.status === StatusCodes.BAD_REQUEST
                ? responseData
                : error,
          },
          LOGERROR
        );
      }
    }
  };

  const loadAllIrrigationFields = async () => {
    const userEmail = loggedInUser;
    try {
      let allGeoJsonPolygon = await GisLayerService.loadAllIrrigationFields();
      dispatch(setAllGeoJsonPolygon(allGeoJsonPolygon));
      dispatch(SetFlagToGetGeoJson(true));
    } catch (error) {
      console.error(ERROR_FETCHING_ALL_IRRIGATION_FIELDS, error);
      FluentdHelper.logEvent(
        ERROR_FETCHING_ALL_IRRIGATION_FIELDS,
        "Dashboard_loadAllIrrigationFields",
        userEmail,
        {
          response: error,
        },
        LOGERROR
      );
    }
  };

  const closeAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  return (
    <div>
      <StaffUserNotes />
      <ConsentPopup />
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text={overlayText}
      />
      <LoadingOverlay
        showSpinner={true}
        active={graphOverlayLoading}
        text={LOADING_GRAPHS}
      />
      {showAlert === true ? (
        <Alert
          key="messageAlert"
          variant={variant}
          closeAlert={(e) => closeAlert(e)}
          alertMessage={alertMessage}
          dismissible
        />
      ) : (
        EMPTY
      )}
      <Container fluid="lg" className="dashboard">
        <Row className="mt-4">
          <Col md={5}>
            <div className="filters">
              <h5>
                <span className="fa fa-filter"></span> Filters
              </h5>
              <Form>
                <Form.Check
                  id="custom-switch"
                  label="Select Custom Date Range"
                  onChange={(event) => setDateFilter(true)}
                  checked={selectRangeStatus}
                />
                <Row id="DateFilter">
                  <Form.Group as={Col} xs="4" controlId="formGridYear">
                    <Form.Label>Year</Form.Label>
                    <Select
                      name="year"
                      options={yearData}
                      className="basic-multi-select"
                      onChange={(e) => onChangeYear(e)}
                      value={year}
                    />
                  </Form.Group>
                  <Form.Group as={Col} xs="8" controlId="formGridMonth">
                    <Form.Label>Month</Form.Label>
                    <Select
                      isMulti
                      name="month"
                      options={monthData}
                      value={month}
                      className="basic-multi-select"
                      onChange={(...args) => handleSelectChange(...args)}
                    />
                  </Form.Group>
                </Row>
                <div id="DateFilterRange" className="hide">
                  <DateRangePicker
                    handleDayClick={handleDayClick}
                    startDate={startDate}
                    endDate={endDate}
                    range={range}
                    datePopoverOpen={datePopoverOpen}
                    setDatePopoverOpen={setDatePopoverOpen}
                    filterText={"Custom Date Range"}
                    disableAfter={false}
                    visibleMonths={visibleMonths}
                    setVisibleMonths={setVisibleMonths}
                  />
                </div>
                <Row>
                  <Form.Group as={Col} controlId="formGridYear">
                    <Form.Label>Business</Form.Label>
                    <Select
                      isMulti
                      name="business"
                      options={businessData}
                      className="basic-multi-select"
                      value={business}
                      onChange={(...args) => handleSelectChange(...args)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="formGridMonth">
                    <Form.Label>Farm</Form.Label>
                    <Select
                      isMulti
                      name="farm"
                      options={farmData}
                      className="basic-multi-select"
                      value={farm}
                      onChange={(...args) => handleSelectChange(...args)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="formGridMonth">
                    <Form.Label>Crop Type</Form.Label>
                    <Select
                      isMulti
                      name="cropType"
                      options={cropTypeData}
                      className="basic-multi-select"
                      value={cropType}
                      onChange={(...args) => handleSelectChange(...args)}
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridMonth">
                    <Form.Label>Tillage Practice</Form.Label>
                    <Select
                      isMulti
                      name="tillage"
                      options={TillagesValue}
                      className="basic-multi-select"
                      value={tillage}
                      onChange={(...args) => handleSelectChange(...args)}
                    />
                  </Form.Group>
                </Row>
                <Button variant="link" onClick={(event) => resetFilter(event)}>
                  Reset Filter
                </Button>
                <Button size="sm" onClick={(event) => updateTableData(event)}>
                  Filter Data
                </Button>
              </Form>
            </div>
          </Col>
          <Col md={7}>
            {showNoRowsMessage ? (
              <h6 align="center" className="chart-title mt-4">
                {NO_FIELDS_REGISTER_IN_MAP}
              </h6>
            ) : filteredData.length === 0 ? (
              <h6 align="center" className="chart-title mt-4">
                {NO_MATCHING_RECORDS}
              </h6>
            ) : dataProcessing ? (
              <h6 align="center" className="chart-title mt-4">
                {RESETTING_FIELD_DATA}
              </h6>
            ) : (
              <div className="filteredTable">
                <DataTable
                  columns={columns}
                  data={filteredData}
                  dense
                  paginationComponentOptions={{ noRowsPerPage: true }}
                  pagination
                  customStyles={DASHBOARD_TABLE_CUSTOM_STYLES}
                  striped
                  responsive
                />
              </div>
            )}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={5} className="position-relative">
            <h4 align="center" className="chart-title">
              {DAILY_IRRIGATION_ACTIVITY}
            </h4>
            <h6 align="center" className="chart-title">
              <div className="graphHeaderTitle">
                {DAILY_WATER_USAGE}{" "}
                {barChartTitleFieldName === EMPTY ? EMPTY : "for Field"}{" "}
                <span className="graphHeaderField">
                  {barChartTitleFieldName}
                </span>
                <br />
              </div>
              <span className="graphSubHeader">{barChartTitleRange}</span>
            </h6>
            <div id="barchart-wrapper" className={showMessage}>
              <BarChart series={barSeries} options={barOptions} />
              <span className="select-message">
                {SELECT_FIELD_FOR_DAILY_WATER_USAGE}
              </span>
            </div>
          </Col>
          <Col md={7} className="position-relative">
            <h4 align="center" className="chart-title">
              {YEARLY_IRRIGATION_ACTIVITY}
            </h4>
            <h6 align="center" className="chart-title">
              <div className="graphHeaderTitle">
                {MONTHLY_WATER_USAGE}{" "}
                {chartTitle === EMPTY ? EMPTY : "for Field"}{" "}
                <span className="graphHeaderField">{chartTitle}</span>
              </div>
            </h6>
            <div id="chart-wrapper" className={showMessage}>
              <LineChart series={series} />
              <span className="select-message">
                {SELECT_FIELD_FOR_MONTHLY_WATER_USAGE}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Dashboard;
